const styles = {
  mainContainer: "bg-white mx-auto max-w-lgs px-4 py-16 sm:px-6 sm:py-24 lg:max-w-xl lg:px-8",
  productCard: "relative",
  imageContainer: "relative h-72 w-full overflow-hidden rounded-lg",
  productInfo: "mt-4",
  productName: "text-lg font-bold text-gray-900",
  productPrice: "text-md text-gray-600",

};

export default styles;
